import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {compose} from "recompose";

/**
 * A component displaying Mode content based on state
 *
 */
class TitleMode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: 'live'
        };
    }

    componentDidMount() {
        const mode = localStorage.getItem('mode');
        this.setState({
            mode: mode
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.mode !== this.props.mode) {
            this.setState({
                mode: nextProps.mode
            });
        }
    }

    render() {
        return (
            <span>
                {this.props.mode === 'test' &&
                <span style={this.props.style}>(Test Mode)</span>
                }
            </span>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['modeForm'];
    if (form && form.values) {
        const selectValue = (form.values['modeSelect']) ? form.values['modeSelect'].toString() : null;
        return {
            mode: selectValue,
        }
    }
    return {}
};

TitleMode.propTypes = {
    mode: PropTypes.string,
    style: PropTypes.object,
};
TitleMode.defaultProps = {
    mode: 'live',
    style: {},
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(TitleMode);


// WEBPACK FOOTER //
// ./src/Fuse/components/TitleMode.js